export const VIDEO_NEGATABLE_FILTERS = [
  "publishDate",
  "riskTier",
  "actionTaken",
  "riskId",
  "safetyStatus",
  "creatorIds",
  "creatorListIds",
  "gmv",
  "productIds",
  "tactics",
  "sellingPoints",
  "videoStyles",
  "hooks",
  "views",
  "ctr",
  "ctor",
  "orders",
  "creatorLevel",
  "followers",
  "maleAudiencePercent",
  "femaleAudiencePercent",
  "age",
  "collaborationType",
  "collaborationIds",
  "campaignIds",
  "videoLanguages",
] as const;

export const CREATORS_NEGATABLE_FILTERS = [
  "riskTier",
  "riskId",
  "creatorListIds",
  "creatorClassifications",
  "includeTagIds",
  "includeCohortIds",
  "productIds",
  "postedDate",
  "gmv",
  "followers",
  "videosAtRiskPercent",
  "ctr",
  "ctor",
  "orders",
  "aov",
  "maleAudiencePercent",
  "femaleAudiencePercent",
  "age",
  "toneAndApproach",
  "contentFocus",
  "productionQuality",
  "topSellingCategories",
  "totalLikes",
  "postingFrequency",
  "collaborationType",
  "campaignIds",
  "creatorLevel",
  "categoryPro",
  "creatorLanguage",
] as const;

export const PRODUCTS_NEGATABLE_FILTERS = [
  "creatorIds",
  "creatorListIds",
  "gmv",
  "status",
  "stockStatus",
  "unitsSold",
  "videos",
  "aov",
  "price",
  "stockLevel",
] as const;

export const CANDIDATE_ATTRIBUTE_NEGATABLE_FILTERS = [
  "followers",
  "gmv",
  "liveGmv",
  "videoGmv",
  "unitsSold",
  "rating",
  "maleAudiencePercent",
  "femaleAudiencePercent",
  "toneAndApproach",
  "contentFocus",
  "productionQuality",
  "topSellingCategories",
  "totalLikes",
  "postingFrequency",
  "creatorLevel",
  "categoryPro",
  "creatorLanguage",
] as const;

export const CANDIDATES_NEGATABLE_FILTERS = [
  ...CANDIDATE_ATTRIBUTE_NEGATABLE_FILTERS,
  "gender",
  "age",
  "includeCohortIds",
] as const;

export const RECOMMENDATIONS_NEGATABLE_FILTERS = [
  ...CANDIDATE_ATTRIBUTE_NEGATABLE_FILTERS,
  "age",
  "includeTagIds",
  "includeCohortIds",
] as const;

export const ASSURANCE_VIDEOS_NEGATABLE_FILTERS = [
  "publishDate",
  "flaggedDate",
  "riskId",
  "actionTaken",
  "riskTier",
  "creatorIds",
  "hooks",
  "productIds",
  "tactics",
  "sellingPoints",
  "videoStyles",
  "videoLanguages",
  "campaignIds",
  "views",
] as const;

export const SEQUENCE_RUNS_NEGATABLE_FILTERS = ["sequenceId", "status"] as const;

export const SAMPLES_NEGATABLE_FILTERS = ["productIds", "collaborationIds", "postRate"] as const;
